<template>
  <div>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.country`]="{ item }">
        <v-icon>{{ item.country.name }}</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminDistrictsList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Country",
          align: "start",
          sortable: false,
          value: "country.name",
          filterable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_districts(
        {
          is_admin: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading districts on admin list", errors);
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/locations/districts/view/" + item.id);
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "DIstricts List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Districts",
          disabled: true,
          href: "/admin/locations/districts/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>